import React from 'react';
import { Icon, Select } from '@ver-uds/uswds-react';
import Button from '../Button';

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50];

export interface PaginationProps {
  dataSize: number;
  pageCount: number;
  pageOptions: number[];
  previousPage: () => void;
  nextPage: () => void;
  gotoPage: (pageIndex: number) => void;
  setPageSize: (pageSize: number) => void;
  canPreviousPage: boolean;
  canNextPage: boolean;
  pageIndex: number;
  pageSize: number;
  pageSizeOptions?: Array<number>;
}

/**
 *
 * @deprecated This component is deprecated.
 * The component `<PaginationV2 />` will be replacing this in the future and some existing props will no longer be used.
 */
const Pagination = ({
  dataSize,
  pageCount,
  pageOptions,
  previousPage,
  nextPage,
  gotoPage,
  setPageSize,
  canPreviousPage,
  canNextPage,
  pageIndex,
  pageSize,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
}: PaginationProps): JSX.Element => {
  const itemsCurrentlyDisplayed = {
    startIndex: dataSize > 0 ? pageIndex * pageSize + 1 : 0,
    endIndex: Math.min((pageIndex + 1) * pageSize, dataSize),
  };

  return (
    <div className="ver-pagination">
      <div className="ver-pagination__rows-per-page">
        <span className="ver-pagination__text">Rows Per Page</span>
        <Select
          className="ver-pagination__selector"
          id="row-count-selector"
          aria-label="Rows per Page Selector"
          value={pageSize}
          onChange={(event): void => setPageSize(parseInt(event.target.value, 10))}
        >
          {pageSizeOptions.map((pageSizeOption) => (
            <option value={pageSizeOption} key={pageSizeOption}>
              {pageSizeOption}
            </option>
          ))}
        </Select>
      </div>
      <div aria-live="polite" className="ver-pagination__row-count">
        <span className="ver-pagination__text">
          {itemsCurrentlyDisplayed.startIndex}-{itemsCurrentlyDisplayed.endIndex} of {dataSize}{' '}
          {dataSize !== 1 ? 'items' : 'item'}
        </span>
      </div>
      <div className="ver-pagination__actions">
        <Button
          type="button"
          className="ver-pagination__arrow"
          variant="tertiary"
          aria-label="Previous Page"
          onClick={previousPage}
          disabled={!canPreviousPage}
        >
          <Icon name="navigate_before" />
        </Button>
        <span className="ver-pagination__text">Page</span>
        <Select
          className="ver-pagination__selector"
          id="page-selector"
          aria-label="Page Selector"
          value={pageIndex}
          onChange={(event): void => gotoPage(parseInt(event.target.value, 10))}
        >
          {pageOptions.map((pageOption) => (
            <option value={pageOption} key={pageOption}>
              {pageOption + 1}
            </option>
          ))}
        </Select>
        <span className="ver-pagination__text">of {pageCount}</span>
        <Button
          type="button"
          className="ver-pagination__arrow"
          variant="tertiary"
          aria-label="Next Page"
          onClick={nextPage}
          disabled={!canNextPage}
        >
          <Icon name="navigate_next" />
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
